import React, { useContext } from 'react';
import { Button, Card, LocaleContext } from 'shared';

import { CompanyDetailsProps } from './CompanyDetails.types';

export const CompanyDetails = ({ onOpenEditModal, account, style }: CompanyDetailsProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <Card className="company-details" style={style}>
      <Card.Header className="company-details__header">
        <Card.Title className="company-details__title">
          {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS' })}:
        </Card.Title>
        <Button
          type={'portal-lite'}
          icon={['1.25rem', 'pencilBlueIcon']}
          iconAfterText={true}
          onClick={onOpenEditModal}
          className="button--edit-company"
        >
          {localeContext.formatMessage({ id: 'ACCOUNT.EDIT-SECTION' })}
        </Button>
      </Card.Header>
      <Card.Body className="company-details__body">
        <Card.Item className="company-details__name">
          <Card.ItemKey className="company-details__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS.COMPANY-NAME' })}:
          </Card.ItemKey>
          <Card.ItemValue className="company-details__value">{account.companyData.name}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="company-details__nip">
          <Card.ItemKey className="company-details__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS.BUSINESS-REGISTRATION-NUMBER' })}:
          </Card.ItemKey>
          <Card.ItemValue className="company-details__value">{account.companyData.nip}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="company-details__country">
          <Card.ItemKey className="company-details__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS.COUNTRY' })}:
          </Card.ItemKey>
          <Card.ItemValue className="company-details__value">{account.companyData.country}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="company-details__website">
          <Card.ItemKey className="company-details__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS.WEBSITE' })}:
          </Card.ItemKey>
          <Card.ItemValue className="company-details__value">{account.companyData.website}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="company-details__address">
          <Card.ItemKey className="company-details__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS.ADDRESS' })}:
          </Card.ItemKey>
          <Card.ItemValue className="company-details__value">
            {account.companyData.address}, {account.companyData.addressDetails} {account.companyData.zipCode}{' '}
            {account.companyData.city}
          </Card.ItemValue>
        </Card.Item>
      </Card.Body>
    </Card>
  );
};
